/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2018, 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'jquery'
], ($) => {

	return class TemplateHelper {

		constructor(options) {
			this._model = options.model;
			this._layoutController = options.layoutController;

			this._model.on('insert:item', this._onNewItem, this);
			this._model.on('remove:item', this._onRemoveItem, this);

			if (this._model.items) {
				for (var i = 0; i < this._model.items.length; i++) {
					this._setChildMonitors(this._model.items[i]);
				}
			}
		}

		/**
		 * Called when the view is destroyed
		 */
		destroy() {
			this._model.off('insert:item', this._onNewItem, this);
			this._model.off('remove:item', this._onRemoveItem, this);
			if (this._model.items) {
				for (var i = 0; i < this._model.items.length; i++) {
					this._setChildMonitors(this._model.items[i], 'off');
				}
			}
		}

		setPreferredLocation(options) {
			let locationSet = false;
			let view = this._layoutController.getLayoutView(this._model.id);
			var emptyDropZones = view.$el.find('.pagetemplateDropZone.empty');

			if (emptyDropZones.length > 0) {
				emptyDropZones[0]._layout.setPreferredLocation(options);
				locationSet = true;
			}
			return locationSet;
		}

		/**
		 * Set or Remove the event listeners to monitor when the layout model changes.
		 * @param childModel
		 * @param {String} sOff (Optional) Set to 'off' to remove listeners.
		 */
		_setChildMonitors(childModel, sOff) {
			var sOnOrOff = (sOff === 'off' ? 'off' : 'on');
			childModel[sOnOrOff]('change:style', this._onChildModelStyleChange, this);
			// childModel[sOnOrOff]('prechange:style', this._onChildModelStylePreChange, this);
			childModel[sOnOrOff]('change:parent', this._onChildModelUpdateParent, this);
		}

		/**
		 * Called when a new layout model is added to this layout.
		 *
		 */
		_onNewItem(payload) {
			var model = this._model.findModel(payload.value.parameter.model.id);
			this._setChildMonitors(model);
			this._updateDropZonesState(model, payload.data);
		}

		/**
		 * Called when a child layout is removed
		 *
		 */
		_onRemoveItem(payload) {
			// Update the drop zone that this layout is snapped to
			let view = this._layoutController.getLayoutView(payload.modelId);
			const dropZones = view.$el.children('.pagetemplateDropZone');
			const id = payload.value.parameter;
			for (let i = 0; i < dropZones.length; i++) {
				dropZones[i]._layout.removeRelatedModel(id, payload);
			}
		}

		_clearDropZoneState(model, payloadData) {
			let view = this._layoutController.getLayoutView(model.id);
			const siblingDropZones = (view && view.$el) ? view.$el.children('.pagetemplateDropZone') : [];
			let dz;
			for (let i = 0; i < siblingDropZones.length; i++) {
				dz = siblingDropZones[i];
				if (dz._layout) {
					const layout = dz._layout;
					layout.removeRelatedModel(model.id, payloadData);
				}
			}
			model.set({ relatedLayouts: '' }, { payloadData: payloadData.data });
		}

		/**
		 * Called when the parent of a child model has changed.
		 */
		_onChildModelUpdateParent(payload) {
			if ((payload.data && payload.data.hint !== 'updateStyleToPercent') && payload.sender !== 'UndoRedoController') {
				var model = this._layoutController.topLayoutModel.findModel(payload.modelId);
				this._clearDropZoneState(model, payload.data);
				this._setChildMonitors(model, 'off');
			}
		}

		/**
		 * Called when the layout style has changed
		 */
		_onChildModelStyleChange(payload) {
			var model = this._layoutController.topLayoutModel.findModel(payload.modelId);
			this._updateDropZonesState(model, payload.data);
		}

		/**
		 * Go over all drop zones and find the drop zone that the given model is snapped to. If one is found, then we will update the dropzone layout to indicate this relationship
		 *
		 */
		_updateDropZonesState(model, payloadData) {
			// Make sure the layout is ready before accessing the node.
			// This function was historically wrapped in a setTimeout. It appears to be required because the widget may not be available in the domNode
			// when layoutReady returns (See RTC 241861).
			setTimeout(() => {
				this._layoutController.layoutReady(model.id).then(() => {
					const content = this._layoutController.dashboardApi.getCanvas().getContent(model.id);
					const view = this._layoutController.getLayoutView(this._model.id);
					const $node = $('#' + this._layoutController.modelIdToNodeId(model.id), view.$el);
					// Check if the layout is snapped to a drop zone. If so, then we mark it as related
					let siblingDropZones = $node.siblings('.pagetemplateDropZone');
					let dz;
					let foundDropZone = null;
					for (var i = 0; i < siblingDropZones.length; i++) {
						dz = siblingDropZones[i];
						if (dz._layout) {
							let layout = dz._layout;
							if (layout.isLayoutRelatedToDropZone($node[0])) {
								foundDropZone = layout;
								foundDropZone.addRelatedModel(model.id, payloadData);
							} else {
								let childrenGroup = content.findContent();
								if (childrenGroup && childrenGroup.length != 0) {
									childrenGroup.forEach((child) => {
										layout.removeRelatedModel(child.getId(), payloadData);
									});
								}
								layout.removeRelatedModel(model.id, payloadData);
							}
						}
					}
					model.set({ relatedLayouts: foundDropZone ? foundDropZone.model.id : '' }, { payloadData: payloadData.data });
				});
			}, 10);
		}
	};
});
